<template>
    <div class="input-group" style="flex-wrap:nowrap">
        <date-picker v-model="dateValue" :config="newConfig" @dp-change="handleInput" ref="picker" :readonly="isPeriodReport"/>
        <span @click="triggerDatePicker"
              v-if="hasIcon"
              class="button-datepicker"
              style="cursor: pointer">
            <i class="icon-calendar icons"/>
        </span>
    </div>
</template>
<script>
/**
 * @author HungNS
 */
import datePicker from 'vue-bootstrap-datetimepicker';
import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/regular.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import "@/styles/simple-line-icons.css";
import "@/styles/bootstrap-datetimepicker.min.css";
import moment from "moment";
import _ from 'lodash';
import $ from 'jquery';

export default {
    name: 'TrsDatePicker',
    components: {
        datePicker
    },
    props: {
        hasIcon: {
            required: false,
            default: false
        },
        disabledDate: {
            required: false,
            type: String
        },
        disableDateOfWeek: {
            required: false,
            default: null
        },
        yearLimit: {
            required: false,
            default: null
        },
        cryptoService: {
            required: false,
            default: null
        },
        fromDate: {
            required: false,
            default: null
        },
        toDate: {
            required: false,
            default: null
        },
        value: {
            required: false,
            default: null
        },
        isPeriodReport: {
            required: false,
            default: null
        }
    },
    data() {
        return {
            dateValue: null,
            dateStart: null,
            dateEnd: null,
            configs: {
                locale: 'ja',
                useCurrent: false,
                format: 'YYYY/MM/DD',
                ignoreReadonly: true,
                icons: {
                    time: 'icon-clock icons',
                    date: 'icon-calendar icons',
                    up: 'icon-arrow-up icons',
                    down: 'icon-arrow-down icons',
                    previous: 'icon-arrow-left icons',
                    next: 'icon-arrow-right icons',
                }
            },
            disabledDateFlg: false
        }
    },
    computed: {
        newConfig() {
            let templeConfig = {...this.configs};
            let disabledDateOfYears = [];
            let disableDateOfWeek = [];
            let minDate;
            if (this.disabledDate) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.disabledDateFlg = true;
                disableDateOfWeek = this.disabledDate.split(",").map(x => Number(x));
                templeConfig = {...templeConfig, daysOfWeekDisabled: disableDateOfWeek};
            } else {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.disabledDateFlg = false;
                templeConfig = {...templeConfig, daysOfWeekDisabled: false};
            }
            if (this.yearLimit && this.isPeriodReport) {
                const currentDate = moment.tz(moment(), 'Asia/Tokyo');
                disabledDateOfYears.push(currentDate.format("YYYY/MM/DD"));
                const maxYear = currentDate.get("year");
                const minYear = currentDate.subtract(Number(this.yearLimit), 'years').get("year");
                if (!this.cryptoService) {
                    for (let year = minYear; year <= maxYear; year++) {
                        disabledDateOfYears.push(moment().year(year).startOf('year').format("YYYY/MM/DD"));
                    }
                }
                const maxDate = this.getPreviousValidDate(moment.tz(moment(), 'Asia/Tokyo').subtract('d', 1), disableDateOfWeek, disabledDateOfYears, false);
                const tempMaxDate = _.clone(maxDate);
                minDate = this.getPreviousValidDate(tempMaxDate.subtract(Number(this.yearLimit), 'years'), disableDateOfWeek, disabledDateOfYears, true);
                templeConfig = {...templeConfig, minDate: minDate.format('YYYY/MM/DD')};
                templeConfig = {...templeConfig, minDate: maxDate.format('YYYY/MM/DD')};
                templeConfig = {...templeConfig, disabledDates: disabledDateOfYears};
            } else if(this.yearLimit && !this.isPeriodReport) {
                minDate = this.getPreviousValidDate(moment.tz(moment(), 'Asia/Tokyo').add('d', 1).subtract(Number(this.yearLimit), 'years'), disableDateOfWeek, disabledDateOfYears, true);
                templeConfig = {...templeConfig, minDate: minDate.format('YYYY/MM/DD')};
            }

            if (this.fromDate || this.toDate) {
                templeConfig = {...templeConfig, maxDate: moment.tz(moment(), 'Asia/Tokyo')};
                if (this.fromDate) {
                    templeConfig = {...templeConfig, minDate: moment(this.fromDate, this.configs.format)}
                } else {
                    templeConfig = {...templeConfig, minDate: minDate ? minDate.format('YYYY/MM/DD') : false}
                }
                if (this.toDate) {
                    templeConfig = {...templeConfig, maxDate: moment(this.toDate, this.configs.format)}
                }
            }

            return templeConfig;
        }
    },
    watch: {
        value: {
            handler(val) {
                this.dateValue = val
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        triggerDatePicker() {
            this.$refs.picker.$el.focus();
        },
        handleInput(e) {
            if (this.disabledDateFlg) {
                const currentDate = moment.tz(moment(), 'Asia/Tokyo').format("YYYY/MM/DD");
                const valueDate = e.target.value;
                if (valueDate === currentDate && this.yearLimit) {
                    $(e.target).val(this.fromDate);
                }

                const SATURDAY = 5;
                const SUNDAY = 6;
                const disableDateOfWeek = [SATURDAY, SUNDAY];
                const day = new Date(valueDate).getUTCDay();
                if(disableDateOfWeek.includes(day)){
                    if (this.fromDate) {
                        if (valueDate < this.value || valueDate > this.value) {
                            $(e.target).val(this.fromDate);
                        }
                    }
                    if (this.toDate){
                        if (valueDate < this.value || valueDate > this.value) {
                            $(e.target).val(this.toDate);
                        }
                    }
                }
            }

            this.$emit('input', e.target.value);
        },
        getPreviousValidDate: function (valueDate, disabledDateOfWeek, disabledDateOfYear, isMinDate) {
            const delta = isMinDate ? -1 : 1;
            while (disabledDateOfWeek.indexOf(valueDate.day()) !== -1 || disabledDateOfYear.indexOf(valueDate.format('YYYY/MM/DD')) !== -1) {
                valueDate = valueDate.subtract("d", delta);
            }
            return valueDate;
        }
    },
}
</script>
<style scoped>
.mx-calendar-content .cell.disabled {
    pointer-events: none !important;
}

.datepicker-range .mx-datepicker {
    width: 100%;
}

.button-datepicker {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 12px;
    font-size: 14px;
    font-weight: normal;
    background-color: #eeeeee;
    border: 1px solid #cccccc;
    border-left: none;
}
</style>
